import router from '@/router'
// import { logReport } from '@/data/api/common/Log/Log'

router.beforeEach((to, from, next) => {
  // logReport().then(res => {
  next()
  // }).catch(() => {})
})
router.afterEach(() => {
})



// WEBPACK FOOTER //
// ./src/common/permission/index.js